import { render, staticRenderFns } from "./AntiPhishing.vue?vue&type=template&id=fa4452a0&scoped=true"
import script from "./AntiPhishing.vue?vue&type=script&lang=js"
export * from "./AntiPhishing.vue?vue&type=script&lang=js"
import style0 from "./AntiPhishing.vue?vue&type=style&index=0&id=fa4452a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4452a0",
  null
  
)

export default component.exports